import { tsv } from "@faire/slate/lib/tsv";
import { isNotUndefined } from "@faire/typescript";
import React, { InputHTMLAttributes } from "react";

import { CheckboxIcon } from "./CheckboxIcon";
import { CHECKBOX_CHECKED } from "./consts";
import { CheckboxChecked } from "./types";
import { getAriaChecked, getChecked } from "./utils";

type IProps = React.PropsWithChildren<
  Omit<
    InputHTMLAttributes<HTMLInputElement>,
    "aria-checked" | "checked" | "type"
  >
> & {
  checked?: CheckboxChecked;
  hasLabel: boolean;
};

export const CheckboxBase: React.FC<IProps> = ({
  checked,
  hasLabel,
  className,
  ...props
}) => {
  const ariaCheckedOrUndefined = isNotUndefined(checked)
    ? getAriaChecked(checked)
    : undefined;
  const checkedOrUndefined = isNotUndefined(checked)
    ? getChecked(checked)
    : undefined;
  return (
    <div className={boxStyle.cls({ hasLabel })}>
      <input
        {...props}
        aria-checked={ariaCheckedOrUndefined}
        checked={checkedOrUndefined}
        className="fs-checkbox__input focusable interactive"
        type="checkbox"
      />
      {/* NOTE(alipianu): to support uncontrolled use case, we render all possible icons and hide all but the one corresponding to checked state via css selectors */}
      {CHECKBOX_CHECKED.map((checked) => (
        <CheckboxIcon key={`${checked}`} checked={checked} />
      ))}
    </div>
  );
};

const boxStyle = tsv({
  base: ["fs-checkbox__box"],
  variants: {
    hasLabel: {
      true: "type-aligned-elem",
    },
  },
});
